<template>
  <b-container fluid>
    <h4 class="mb-4">
      <strong>Equipamento </strong>
    </h4>

      <template v-if="loading">
      <a-skeleton active />
    </template>

    <template v-else>
      <Form :device="device" class="mt-2"></Form>
    </template>
  </b-container>
</template>

<script>
import Form from "./formulario";
import { EquipamentosResource } from "@/resources/Equipamentos.resource.js";

export default {
  components: {
    Form
  },
  data() {
    return {
      loading: true,
      device: {}
    };
  },
  created() {
    if (this.$route.params.id > 0) {
      this.getDispositivo(this.$route.params.id);
    } else {
      this.loading = false;
    }
  },

  methods: {
    getDispositivo(_idDevice) {
      this.loading = true;
      const v = this;
      EquipamentosResource.getEquipamento({ idDevice: _idDevice })
        .then(result => {
          try {
            v.device = result.data.payload;
            v.loading = false;
          } catch (e) {
            throw {
              response: {
                data: {
                  failureReason:
                    "Ocorreu uma erro ao carregar os dados da Maquineta"
                }
              }
            };
          }
        })
        .catch(e => {
          this.loading = false;
        });
    }
  }
};
</script>
